import BaseRequestBuilder from 'nast-api/RequestBuilder'

const VERSION_API = '2'
/**
 * A class that extends the BaseRequestBuilder to provide additional functionality
 * for building requests in the Cool API.
 */
export class RequestBuilder extends BaseRequestBuilder {
  _version = VERSION_API
}
/**
 * Creates and configures the Cool API and Nast API instances.
 *
 * @param {Object} s - Settings.
 * @param {Object} l - Libs
 * @return {Object} An object containing the configured `coolApi` and `nastApi` instances.
 */
export function createCoolApi(s, l) {
  const coolConfig = $config('api')
  // coolConfig.servers.default = window.__PROSPER_ENV__('server')
  coolConfig.servers.default = $env('server')
  const coolApi = new s.api.CoolRestApi()
  const nastApi = new l.api.NastApi(RequestBuilder, coolConfig, $app.store._store)
  return { coolApi, nastApi }
}